<h2 mat-dialog-title class="mb-0">Change your Password!</h2>
<form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
    <mat-dialog-content class="py-1">
        It seems you are logging in for the first time. We suggest you to change your password.
        <div class="auth">
            <div class="input-field mt-5">
                <mat-form-field appearance="outline">
                    <mat-label>New Password</mat-label>
                    <input type="{{ hidePassword ? 'password' : 'text' }}" matInput autocomplete="off"
                        formControlName="password1" [errorStateMatcher]="matcher">
                    <mat-icon matSuffix (click)="togglePasswordVisibility()" class="cursor-pointer"><ng-icon
                            name="{{ hidePassword ? 'heroEye' : 'heroEyeSlash' }}"></ng-icon></mat-icon>
                    <mat-error *ngIf="resetForm.get('password1').hasError('required')">
                        New Password is required
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="input-field">
                <mat-form-field appearance="outline">
                    <mat-label>Confirm Password</mat-label>
                    <input type="{{ hidePassword ? 'password' : 'text' }}" matInput autocomplete="off"
                        formControlName="password2" [errorStateMatcher]="matcher">
                    <mat-icon matSuffix (click)="togglePasswordVisibility()" class="cursor-pointer"><ng-icon
                            name="{{ hidePassword ? 'heroEye' : 'heroEyeSlash' }}"></ng-icon></mat-icon>
                    <mat-error *ngIf="resetForm.get('password2').hasError('required')">
                        Confirm Password is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button color="accent" mat-raised-button type="submit" class="loading-btn mb-2" [disabled]="isLoading">Submit
            <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
        </button>
    </mat-dialog-actions>
</form>